import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { DIAGRAM_COMMON_REDUCER_TOKEN, diagramCommonReducerProvider, rootReducerKey } from './common.reducer';
import { EffectsModule } from '@ngrx/effects';
import { DiagramCommonEffects } from './common.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(rootReducerKey, DIAGRAM_COMMON_REDUCER_TOKEN),
    EffectsModule.forFeature([DiagramCommonEffects])
  ],
  providers: [
    diagramCommonReducerProvider
  ]
})
export class DiagramCommonStoreModule { }
